module.exports = __webpack_public_path__ + "img/menu-4.b7d9039b.png";